module.exports = __webpack_public_path__ + "static/img/blue_animate2.83404143.png";